import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import styles from 'styles/components/landing/melodyHeaderRule.scss';

export const MelodyHeaderRule = () => (
  <hr className={styles.melodyRule}/>
);

export default withErrorBoundary('MelodyHeaderRule', MelodyHeaderRule);
